/*
 * @Author: Vanny
 * @Date: 2018-09-13 14:39:03
 * @LastEditors: Vanny
 * @LastEditTime: 2020-02-28 20:51:15
 * @Description: 帮助中心的仓库
 */
import Vue from 'vue'
import Vuex from 'vuex'

import { isArray } from 'util'
import service from '../service'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    appInfo: {},
    userInfo: {},
    bannerList: [],
    hotList: [],
    service: {},
    list: [],
    article: {},
    search: [],
    groupList: [],
    groupMap: {},
  },
  getters: {
    getAppInfo(s) {
      return s.appInfo
    },
    getUserInfo(s) {
      return s.userInfo
    },
    getBannerList(s) {
      return s.bannerList.map(({ name, url, image }) => ({
        src: image,
        title: name,
        href: /^https?:\/\//.test(url)
          ? `/extra-link?url=${url}&name=${name}`
          : url,
      }))
    },
    getSomeHotList(s) {
      return s.hotList.map((v) => ({
        name: v.title,
        url: `/detail?id=${v.id}`,
      }))
    },
    getServiceList(s) {
      const ser = isArray(s.service.children)
        ? s.service.children
        : (s.service.children || {}).data || []
      return ser.map(({ name, children }) => ({
        name,
        children: (isArray(children)
          ? children
          : (children || {}).data || []
        ).map((v) => ({
          name: v.name,
          url: `/list?name=${v.name}&id=${v.id}`,
        })),
      }))
    },
    getGroupList(s) {
      return s.list.map((v) => ({
        name: v.title,
        url: `/detail?id=${v.id}`,
      }))
    },
    getArticle(s) {
      return s.article
    },
    getProblemList(s) {
      if (s.search.length) {
        // 数组
        return s.search.map((v) => ({
          name: v.title,
          url: `/detail?id=${v.id}`,
        }))
      }
      const M = new Map()
      const keys = Object.keys(s.search)
      if (keys.length) {
        // 对象
        keys.forEach((v) => {
          const key = v
            .split('/')
            .slice(0, 2)
            .join('/')
          const val = s.search[v].map(({ title, id }) => ({
            name: title,
            url: `/detail?id=${id}`,
          }))
          if (M.has(key)) {
            M.set(key, [...M.get(key), ...val])
          } else {
            M.set(key, val)
          }
        })
        return [...M]
      }
      return s.search
    },
  },
  actions: {
    requestData({ commit }, payload) {
      commit({
        type: 'update',
        ...payload,
      })
    },
    async requestUserInfo({ commit }) {
      const res = await service.getUserInfo()
      if (res.status === 200 && !res.data.err) {
        commit({
          type: 'update',
          method: 'userInfo',
          payload: res.data,
        })
      } else {
        // 错误处理
        // console.error(response.data)
      }
    },
    async requestBannerList({ commit }) {
      const res = await service.getBannerList()
      if (res.status === 200 && !res.data.err) {
        commit({
          type: 'update',
          method: 'bannerList',
          payload: res.data.data,
        })
      } else {
        // 错误处理
        // console.error(response.data)
      }
    },
    async requestProblemSource({ commit }) {
      const res = await service.getProblemSource()
      if (res.status === 200 && !res.data.err) {
        commit({
          type: 'update',
          method: 'groupList',
          payload: res.data.slice(0, 4),
        })
        commit({
          type: 'update',
          method: 'groupMap',
          payload: res.data.reduce((acc, v) => {
            acc[v.id] = v
            return acc
          }, {}),
        })
      } else {
        // 错误处理
        // console.error(response.data)
      }
    },
    async requestSomeHotList({ commit }, { id }) {
      const res = await service.getSomeHotList(id)
      if (res.status === 200 && !res.data.err) {
        commit({
          type: 'update',
          method: 'hotList',
          payload: res.data.data,
        })
      }
    },
    async requestServiceList({ commit, state }, { id }) {
      const { groupMap } = state

      if (groupMap[id]) {
        commit({
          type: 'update',
          method: 'service',
          payload: groupMap[id],
        })
      } else {
        const res = await service.getServiceList(id)
        if (res.status === 200 && !res.data.err) {
          commit({
            type: 'update',
            method: 'service',
            payload: res.data.data,
          })
        }
      }
    },
    async requestGroupList({ commit }, payload) {
      const res = await service.getGroupList(payload)
      if (res.status === 200 && !res.data.err) {
        commit({
          type: 'update',
          method: 'list',
          payload: res.data.data,
        })
      }
    },
    async requestArticle({ commit }, { id }) {
      const res = await service.getArticle(id)
      if (res.status === 200 && !res.data.err) {
        commit({
          type: 'update',
          method: 'article',
          payload: res.data.data,
        })
        document.title = (res.data.data || {}).title || '详情'
      }
    },
    async sendMessage(_, payload) {
      return service.sendMessage(payload)
    },
    async requestSearch({ commit }, payload) {
      const res = await service.searchProblem(payload)
      if (res.status === 200 && !res.data.err) {
        commit({
          type: 'update',
          method: 'search',
          payload: res.data.data,
        })
      }
    },
  },
  modules: {},
  mutations: {
    update(state, { method, payload }) {
      state[method] = payload
    },
  },
})



// WEBPACK FOOTER //
// ./src/views/help-center/store/index.js